// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimActivityBreakdownRecordDto
 */
export interface IClaimActivityBreakdownRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    employment_status?: string;
    /**
     * 
     * @type {Date}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    employment_status_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    claim_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    claim_type?: string;
    /**
     * 
     * @type {Date}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    claim_submit_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    service_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    service_type?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    claim_status?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    denial_reason?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    requested_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    approved_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    acct_paid_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    total_paid_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    payment_status?: string;
    /**
     * 
     * @type {Date}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    paid_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    payment_method?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    origination?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    account_type?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    plan_year?: string;
    /**
     * 
     * @type {Date}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    plan_year_begin?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    plan_year_end?: Date;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    partner_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    partner_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    distributor_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    employer_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    subsidiary_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    employer_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    id_source?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    employee_id?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof IClaimActivityBreakdownRecordDto
     */
    custom_field_name_to_value?: { [key: string]: string; };
}

/**
 * Check if a given object implements the IClaimActivityBreakdownRecordDto interface.
 */
export function instanceOfIClaimActivityBreakdownRecordDto(value: object): value is IClaimActivityBreakdownRecordDto {
    return true;
}

export function IClaimActivityBreakdownRecordDtoFromJSON(json: any): IClaimActivityBreakdownRecordDto {
    return IClaimActivityBreakdownRecordDtoFromJSONTyped(json, false);
}

export function IClaimActivityBreakdownRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimActivityBreakdownRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employment_status': json['employment_status'] == null ? undefined : json['employment_status'],
        'employment_status_date': json['employment_status_date'] == null ? undefined : (new Date(json['employment_status_date'])),
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'claim_type': json['claim_type'] == null ? undefined : json['claim_type'],
        'claim_submit_date': json['claim_submit_date'] == null ? undefined : (new Date(json['claim_submit_date'])),
        'service_on': json['service_on'] == null ? undefined : (new Date(json['service_on'])),
        'service_type': json['service_type'] == null ? undefined : json['service_type'],
        'claim_status': json['claim_status'] == null ? undefined : json['claim_status'],
        'denial_reason': json['denial_reason'] == null ? undefined : json['denial_reason'],
        'requested_amount': json['requested_amount'] == null ? undefined : json['requested_amount'],
        'approved_amount': json['approved_amount'] == null ? undefined : json['approved_amount'],
        'acct_paid_amount': json['acct_paid_amount'] == null ? undefined : json['acct_paid_amount'],
        'total_paid_amount': json['total_paid_amount'] == null ? undefined : json['total_paid_amount'],
        'payment_status': json['payment_status'] == null ? undefined : json['payment_status'],
        'paid_date': json['paid_date'] == null ? undefined : (new Date(json['paid_date'])),
        'payment_method': json['payment_method'] == null ? undefined : json['payment_method'],
        'origination': json['origination'] == null ? undefined : json['origination'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'plan_year': json['plan_year'] == null ? undefined : json['plan_year'],
        'plan_year_begin': json['plan_year_begin'] == null ? undefined : (new Date(json['plan_year_begin'])),
        'plan_year_end': json['plan_year_end'] == null ? undefined : (new Date(json['plan_year_end'])),
        'partner_external_identifier': json['partner_external_identifier'] == null ? undefined : json['partner_external_identifier'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'distributor_external_identifier': json['distributor_external_identifier'] == null ? undefined : json['distributor_external_identifier'],
        'employer_external_identifier': json['employer_external_identifier'] == null ? undefined : json['employer_external_identifier'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'subsidiary_external_identifier': json['subsidiary_external_identifier'] == null ? undefined : json['subsidiary_external_identifier'],
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'id_source': json['id_source'] == null ? undefined : json['id_source'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'custom_field_name_to_value': json['custom_field_name_to_value'] == null ? undefined : json['custom_field_name_to_value'],
    };
}

export function IClaimActivityBreakdownRecordDtoToJSON(json: any): IClaimActivityBreakdownRecordDto {
    return IClaimActivityBreakdownRecordDtoToJSONTyped(json, false);
}

export function IClaimActivityBreakdownRecordDtoToJSONTyped(value?: IClaimActivityBreakdownRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employment_status': value['employment_status'],
        'employment_status_date': value['employment_status_date'] == null ? undefined : ((value['employment_status_date']).toISOString().substring(0,10)),
        'claim_id': value['claim_id'],
        'claim_type': value['claim_type'],
        'claim_submit_date': value['claim_submit_date'] == null ? undefined : ((value['claim_submit_date']).toISOString().substring(0,10)),
        'service_on': value['service_on'] == null ? undefined : ((value['service_on']).toISOString().substring(0,10)),
        'service_type': value['service_type'],
        'claim_status': value['claim_status'],
        'denial_reason': value['denial_reason'],
        'requested_amount': value['requested_amount'],
        'approved_amount': value['approved_amount'],
        'acct_paid_amount': value['acct_paid_amount'],
        'total_paid_amount': value['total_paid_amount'],
        'payment_status': value['payment_status'],
        'paid_date': value['paid_date'] == null ? undefined : ((value['paid_date']).toISOString().substring(0,10)),
        'payment_method': value['payment_method'],
        'origination': value['origination'],
        'account_type': value['account_type'],
        'plan_name': value['plan_name'],
        'plan_year': value['plan_year'],
        'plan_year_begin': value['plan_year_begin'] == null ? undefined : ((value['plan_year_begin']).toISOString().substring(0,10)),
        'plan_year_end': value['plan_year_end'] == null ? undefined : ((value['plan_year_end']).toISOString().substring(0,10)),
        'partner_external_identifier': value['partner_external_identifier'],
        'partner_name': value['partner_name'],
        'distributor_external_identifier': value['distributor_external_identifier'],
        'employer_external_identifier': value['employer_external_identifier'],
        'employer_name': value['employer_name'],
        'subsidiary_external_identifier': value['subsidiary_external_identifier'],
        'subsidiary_name': value['subsidiary_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'partner_employee_id': value['partner_employee_id'],
        'employer_employee_id': value['employer_employee_id'],
        'ssn': value['ssn'],
        'id_source': value['id_source'],
        'employee_id': value['employee_id'],
        'custom_field_name_to_value': value['custom_field_name_to_value'],
    };
}

